(function(global) {
  'use strict';

  /* ===================================================================
     catalog-utils.js — shared browser-side utilities for all catalogs
     =================================================================== */

  /* ====== HTML Escaping ====== */
  global.GachaUtils = global.GachaUtils || {};
  global.GachaUtils.DEPLOY = 'hash=5a3f36a 2026-10-26 01:22 +08';

  GachaUtils.escapeHtml = function(s) {
    return String(s || '').replace(/[&<>"]|'/g, function(m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  };

  /* ====== ID Obfuscation (Legacy — single layer: reverse + swap + prefix) ====== */
  /* Kept for backward compatibility with un-migrated catalogs */
  GachaUtils.obfuscateId = function(id, prefix) {
    if (!id) return '';
    if (!prefix) prefix = 'ACC';
    var chars = String(id).split('').reverse();
    for (var i = 0; i + 1 < chars.length; i += 2) {
      var t = chars[i];
      chars[i] = chars[i + 1];
      chars[i + 1] = t;
    }
    return prefix + '-' + chars.join('');
  };

  /* Decode (legacy): strip prefix → swap adjacent pairs → reverse */
  GachaUtils.deobfuscateId = function(publicId) {
    if (!publicId) return '';
    var core = String(publicId).trim();
    if (core.includes('----')) {
      core = core.split('----')[0];
    }
    if (core.includes('-')) {
      core = core.split('-')[1];
    } else if (core.length > 5 && (core.length > 12 || /^[A-Z]{2}/.test(core))) {
      core = core.substring(2, core.length - 2);
    }
    var chars = core.split('');
    for (var i = 0; i + 1 < chars.length; i += 2) {
      var t = chars[i];
      chars[i] = chars[i + 1];
      chars[i + 1] = t;
    }
    return chars.reverse().join('');
  };

  /* ====== ID Obfuscation V2 (2-Layer Cipher) ====== */

  /* Layer 1: Character Substitution Cipher */
  var CIPHER_INPUT = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_.@';
  var CIPHER_OUTPUT = '0RQbr6zOj2d.PUstN73DCcmnG-fxvIe_SEWlTqkY8u95MgoBAwZ14VLKHh@iFXyJpa';

  /* Provider IDs (2-char codes for data sources) */
  GachaUtils.PROVIDER_IDS = {
    bssy: 'BS',
    mxwy: 'MX',
    green: 'GR',
    chushi: 'CH',
    naonao: 'NN',
    kikiyx: 'KK',
    zxw: 'ZX',
    ak07: 'AK',
    yoyoacc: 'YO'
  };

  /* Game IDs (2-char codes for game titles) */
  GachaUtils.GAME_IDS = {
    trickcal: 'TR',
    limbuscompany: 'LC',
    genshinimpact: 'GI',
    zenlesszonezero: 'ZZ',
    wuwa: 'WW',
    czn: 'CZ'
  };

  /* Reverse mapping: 2-char code → display name */
  GachaUtils.PROVIDER_NAMES = (function() {
    var m = {};
    var list = { BS: 'BSSY', MX: 'MXWY', GR: 'GREEN', CH: 'Chushi', NN: 'Naonao', KK: 'Kikiyx', ZX: 'ZXW', AK: 'AK07', YO: 'YOYOACC' };
    Object.keys(list).forEach(function(k) { m[k] = list[k]; });
    return m;
  })();

  GachaUtils.GAME_NAMES = (function() {
    var m = {};
    var list = { TR: 'Trickcal: Chibi Go', LC: 'Limbus Company', GI: 'Genshin Impact', ZZ: 'Zenless Zone Zero', WW: 'Wuthering Waves', CZ: 'Chaos Zero Nightmare' };
    Object.keys(list).forEach(function(k) { m[k] = list[k]; });
    return m;
  })();

  /* Encode V2: providerCode + privateId + gameCode → 2-layer cipher */
  GachaUtils.obfuscateIdV2 = function(privateId, providerCode, gameCode) {
    if (!privateId) return '';
    providerCode = providerCode || '__';
    gameCode = gameCode || '__';
    var raw = providerCode + privateId + gameCode;
    var substituted = raw.split('').map(function(c) {
      var idx = CIPHER_INPUT.indexOf(c);
      return idx >= 0 ? CIPHER_OUTPUT[idx] : c;
    }).join('');
    var chars = substituted.split('').reverse();
    for (var i = 0; i + 1 < chars.length; i += 2) {
      var t = chars[i];
      chars[i] = chars[i + 1];
      chars[i + 1] = t;
    }
    return chars.join('');
  };

  /* Decode V2: publicId → { privateId, providerCode, gameCode } */
  GachaUtils.deobfuscateIdV2 = function(publicId) {
    if (!publicId) return { privateId: '', providerCode: '', gameCode: '' };
    var core = String(publicId).trim();
    if (core.includes('----')) {
      core = core.split('----')[0];
    }
    var chars = core.split('');
    for (var i = 0; i + 1 < chars.length; i += 2) {
      var t = chars[i];
      chars[i] = chars[i + 1];
      chars[i + 1] = t;
    }
    var substituted = chars.reverse().join('');
    var raw = substituted.split('').map(function(c) {
      var idx = CIPHER_OUTPUT.indexOf(c);
      return idx >= 0 ? CIPHER_INPUT[idx] : c;
    }).join('');
    if (raw.length < 4) return { privateId: raw, providerCode: '', gameCode: '' };
    return {
      providerCode: raw.substring(0, 2),
      privateId: raw.substring(2, raw.length - 2),
      gameCode: raw.substring(raw.length - 2)
    };
  };

  /* ====== Toast Notifications ====== */
  var _toastTimer = null;

  GachaUtils.showToast = function(msg, duration) {
    var toast = document.querySelector('#toast');
    if (!toast) return;
    if (msg) {
      var toastSpan = toast.querySelector('.toast-content span');
      if (toastSpan) { toastSpan.textContent = msg; }
      else { toast.textContent = msg; }
    }
    toast.classList.remove('hidden', 'show');
    toast.offsetHeight;
    toast.classList.add('show');
    if (_toastTimer) clearTimeout(_toastTimer);
    if (duration !== 0) {
      _toastTimer = setTimeout(function() {
        toast.classList.remove('show');
        setTimeout(function() { toast.classList.add('hidden'); }, 300);
      }, duration || 3000);
    }
  };

  GachaUtils.hideToast = function() {
    var toast = document.querySelector('#toast');
    if (!toast) return;
    if (_toastTimer) clearTimeout(_toastTimer);
    toast.classList.remove('show');
    setTimeout(function() { toast.classList.add('hidden'); }, 300);
  };

  /* ====== Clipboard ====== */
  GachaUtils.copyToClipboard = function(text, msg) {
    var fallback = function(t) {
      var ta = document.createElement('textarea');
      ta.value = t;
      ta.style.cssText = 'position:fixed;left:-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); GachaUtils.showToast(msg || 'ID copied!'); } catch (e) {}
      document.body.removeChild(ta);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function() {
        GachaUtils.showToast(msg || 'ID copied!');
      }).catch(function() {
        fallback(text);
      });
    } else {
      fallback(text);
    }
  };

  /* ====== Settings Parser ====== */
  GachaUtils.parseSettings = function(elementId) {
    var defaults = { translations_json: '{}', images_json: '{}', api_toggles: {}, api_priority: {} };
    try {
      var el = document.getElementById(elementId);
      if (el) {
        var parsed = JSON.parse(el.textContent);
        for (var key in defaults) {
          if (parsed[key] === undefined) parsed[key] = defaults[key];
        }
        return parsed;
      }
    } catch (e) { /* parse error, use defaults */ }
    return defaults;
  };

  /* ====== Translation & Image Map Builders ====== */
  GachaUtils.buildTranslationMap = function(translationsJson) {
    var map = {};
    try {
      var data = JSON.parse(translationsJson || '{}');
      Object.keys(data).forEach(function(key) {
        var val = typeof data[key] === 'string' ? data[key].trim() : data[key];
        key.split('|').map(function(k) { return k.trim(); }).forEach(function(k) {
          if (k) map[k] = val;
        });
      });
    } catch (e) {}
    return map;
  };

  GachaUtils.buildImageMap = function(imagesJson) {
    var map = {};
    try {
      var data = JSON.parse(imagesJson || '{}');
      Object.keys(data).forEach(function(key) {
        var val = typeof data[key] === 'string' ? data[key].trim() : data[key];
        key.split('|').map(function(k) { return k.trim(); }).forEach(function(k) {
          if (k) map[k] = val;
        });
      });
    } catch (e) {}
    return map;
  };

  /* ====== Selection State UI ====== */
  GachaUtils.updateSelectedUI = function(selectedObj) {
    var total = 0;
    if (selectedObj) {
      var keys = Object.keys(selectedObj);
      for (var i = 0; i < keys.length; i++) total += (selectedObj[keys[i]].count || 0);
    }
    var el = document.querySelector('#selectedCount');
    if (el) el.textContent = total;
  };

  /* ====== Thumb Display (badge + selected state) ====== */
  GachaUtils.updateThumbDisplay = function(thumb, count) {
    var existingBadge = thumb.querySelector('.count-badge');
    if (count > 0) {
      thumb.classList.add('selected');
      if (existingBadge) {
        existingBadge.textContent = count;
      } else {
        var b = document.createElement('div');
        b.className = 'count-badge';
        b.textContent = count;
        var imgContainer = thumb.querySelector('.thumb-img-container');
        if (imgContainer) imgContainer.appendChild(b);
      }
    } else {
      thumb.classList.remove('selected');
      if (existingBadge) existingBadge.remove();
    }
  };

  /* ====== Char Grid HTML builder ====== */
  GachaUtils.buildCharGridHTML = function(chars, opts) {
    opts = opts || {};
    var translateName = opts.translateName || function(n) { return n; };
    var getCustomImage = opts.getCustomImage || function() { return null; };
    var isCatalogItem = opts.isCatalogItem || function() { return true; };
    return chars.map(function(c) {
      var src = getCustomImage(c.name) || c.img || '';
      var label = translateName(c.name);
      var countHtml = c.count > 1 ? '<div class="char-count">x' + c.count + '</div>' : '';
      var extraClass = isCatalogItem(c) ? '' : ' not-in-catalog';
      return '<div class="char' + extraClass + '"><div class="char-img-container"><img src="' + GachaUtils.escapeHtml(src) + '" alt="' + GachaUtils.escapeHtml(label) + '" title="' + GachaUtils.escapeHtml(label) + '" loading="lazy" />' + countHtml + '</div><div class="cname">' + GachaUtils.escapeHtml(label) + '</div></div>';
    }).join('');
  };

  /* ====== Infinite Scroll Observer Factory ====== */
  GachaUtils.createSentinelObserver = function(opts) {
    opts = opts || {};
    var onBatch = opts.onBatch || function() {};
    var onLoadMore = opts.onLoadMore || function() {};
    var resultObserver = new IntersectionObserver(function(entries) {
      if (!entries[0].isIntersecting) return;
      if (opts.hasMoreBatch) {
        onBatch();
      } else if (opts.hasMoreApi) {
        onLoadMore();
      }
    }, { rootMargin: opts.rootMargin || '200px' });
    return resultObserver;
  };

  /* ====== Scroll to results ====== */
  GachaUtils.scrollToResults = function(selector) {
    var el = document.querySelector(selector || '#results');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ====== Observe last result card for infinite scroll ====== */
  GachaUtils.observeLastResultCard = function(container, observer) {
    var lastCard = container.lastElementChild;
    if (lastCard && observer) observer.observe(lastCard);
  };

  /* ====== Price Check Modal ====== */
  GachaUtils.initPriceModal = function(opts) {
    opts = opts || {};
    var copyFn = opts.copyToClipboard || GachaUtils.copyToClipboard;
    var modal = document.createElement('div');
    modal.id = 'priceCheckModal';
    modal.className = 'modal-backdrop hidden';
    modal.innerHTML =
'<div class="modal-content">\
    <div class="modal-header">\
        <h3>Price Check Inquiry</h3>\
        <button class="close-modal">&times;</button>\
    </div>\
    <div class="modal-body">\
        <p class="step-header">Step 1: Copy Account ID</p>\
        <div class="id-display-box highlighted">\
            <span>Account ID:</span>\
            <code id="modalAccountId">---</code>\
            <input type="hidden" id="modalFullId" value="">\
            <button class="copy-mini-btn" id="modalCopyBtn">Copy</button>\
        </div>\
        <div class="modal-divider"></div>\
        <p class="step-header">Step 2: Choose Contact Method For Price Quotation</p>\
        <div class="contact-row">\
            <div class="contact-option primary">\
                <div class="opt-icon">✨</div>\
                <div class="opt-details">\
                    <strong>Direct Message</strong>\
                    <a href="https://discord.com/users/477359052662243349" target="_blank" class="modal-btn">DM Admin</a>\
                </div>\
            </div>\
            <div class="contact-option secondary">\
                <div class="opt-icon">🌸</div>\
                <div class="opt-details">\
                    <strong>Join Server</strong>\
                    <a href="https://discord.com/invite/exvg8GR8sk" target="_blank" class="modal-btn">Join & DM CL</a>\
                </div>\
            </div>\
        </div>\
        <p class="modal-hint">(Discord Tag: <code>gachamacha2025</code>)</p>\
    </div>\
</div>';
    document.body.appendChild(modal);

    var closeBtn = modal.querySelector('.close-modal');
    closeBtn.onclick = function() { modal.classList.add('hidden'); };
    modal.onclick = function(e) {
      if (e.target === modal) modal.classList.add('hidden');
    };

    var cpBtn = modal.querySelector('#modalCopyBtn');
    cpBtn.onclick = function() {
      var fullId = document.querySelector('#modalFullId').value;
      copyFn(fullId);
      cpBtn.textContent = 'Copied!';
      setTimeout(function() { cpBtn.textContent = 'Copy'; }, 2000);
    };
  };

  GachaUtils.showPriceCheck = function(id, fullId) {
    var modal = document.querySelector('#priceCheckModal');
    if (!modal) return;
    document.querySelector('#modalAccountId').textContent = id;
    document.querySelector('#modalFullId').value = fullId || id;
    modal.classList.remove('hidden');
  };

  /* ====== Result Header HTML Builder ====== */
  GachaUtils.buildResultHeaderHTML = function(opts) {
    opts = opts || {};
    var displayId = opts.displayId || '';
    return '<div class="result-header">\
    <div>Account ID: <strong>' + GachaUtils.escapeHtml(displayId) + '</strong></div>\
    <div class="header-btns">\
        <button class="copy-btn">Copy ID</button>\
        <button class="price-btn">Price Check</button>\
    </div>\
</div>';
  };

  GachaUtils.wireResultHeaderButtons = function(card, opts) {
    opts = opts || {};
    var copyBtn = card.querySelector('.copy-btn');
    var priceBtn = card.querySelector('.price-btn');
    if (copyBtn && opts.onCopy) copyBtn.onclick = opts.onCopy;
    if (priceBtn && opts.onPriceCheck) priceBtn.onclick = opts.onPriceCheck;
  };

  /* ====== Auto-deploy check ====== */
  console.log('[GachaUtils] LIVE: ' + (GachaUtils.DEPLOY || 'no stamp'));

})(window);
